import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ToastTypes, withToast } from "../../contexts/toastr.context";
import { COMMUNITY_MEMBERS_BULK_ACTION_PAGE_ROUTE } from "./comunity-members-bulk-action.page";

import cx from "classnames";
import { connect } from "react-redux";
import PremiumChip from "../../_components/premium/premium-chip.component";
import { history } from "../../_config";
import { COMMUNITY_HOMEPAGE_ROUTE } from "../community-home/community-home.page";
import { LEADERBOARD_PAGE_ROUTE } from "../leaderboard.page";
import { BULK_MAIL_PAGE_ROUTE } from "./bulk-mail";
import { CUSTOM_PUSH_PAGE_ROUTE } from "./custom-push";
import { INVITE_MEMBERS_SETTINGS_PAGE_ROUTE } from "./invite-user-settings.page";
import { SUBSCRIPTION_PAGE_ROUTE } from "./subscriptions/subscriptions-list/subscriptions-page";

function CommunitySettingSidebarComponent({
  user,
  community,
  communityPac,
  addToast = (e) => {},
  history,
  isSidebarOpen = false,
  sidebarIgnoresCommunitySwitcher = false,
  setIsSidebarOpen = (e) => {},
}) {
  return (
    <div
      onClick={(e) => {
        setIsSidebarOpen(false);
      }}
      className={cx("Sidebar CommunitySettingsSidebar ", {
        open: isSidebarOpen,
      })}>
      <div className="sidebar-content theme-bg-surface p-3 py-2">
        <a href={COMMUNITY_HOMEPAGE_ROUTE}>
          <div className="SidebarHeader my-4 flex items-center space-x-4">
            <span className="mt-1">
              <i className="fi fi-rr-angle-left text-md theme-text-default"></i>
            </span>
            <span className="theme-text-default"> Go Back to Community</span>
          </div>
        </a>
        <div className="SidebarHeader">Manage Members</div>
        <SidebarLink
          addToast={addToast}
          label="Members"
          link={COMMUNITY_MEMBERS_BULK_ACTION_PAGE_ROUTE}
        />
        <SidebarLink
          addToast={addToast}
          label="Leaderboard"
          link={LEADERBOARD_PAGE_ROUTE}
          isPremiumAvailable={communityPac.leaderboard}
        />
        <SidebarLink
          label="Invite"
          link={INVITE_MEMBERS_SETTINGS_PAGE_ROUTE}
          addToast={addToast}
        />
        <SidebarLink
          label="Send Bulk Mail"
          link={BULK_MAIL_PAGE_ROUTE}
          addToast={addToast}
        />
        <SidebarLink
          label="Subscriptions"
          link={SUBSCRIPTION_PAGE_ROUTE}
          addToast={addToast}
        />
        <SidebarLink
          label="Custom Push Notification"
          link={CUSTOM_PUSH_PAGE_ROUTE}
          addToast={addToast}
        />
      </div>
    </div>
  );
}

function SidebarLink({
  label = "Link",
  link = "/settings",
  addToast,
  external = false,
  isPremiumAvailable = true,
}) {
  const [active, setActive] = useState(window.location.pathname === link);

  useEffect(() => {
    const listeners = history.listen((location, action) => {
      setActive(location.pathname === link);
    });

    return () => {
      listeners();
    };
  }, []);

  return !external ? (
    <Link
      to={link}
      onClick={(e) => {
        if (!link) {
          addToast("Coming soon!");
          e.preventDefault();
        }
      }}
      className={cx("SidebarLink flex items-center px-8 my-1", {
        "theme-text-on-primary rounded theme-bg-primary": active,
        "theme-text-heading-2 hover:theme-bg-default": !active,
      })}>
      {label}
      <PremiumChip isAvailable={isPremiumAvailable} className="ml-auto" />
    </Link>
  ) : (
    <a
      href={link}
      onClick={(e) => {
        if (!isPremiumAvailable) {
          addToast(
            "Upgrade to premium plan to enable this feature",
            "",
            ToastTypes.info
          );
          e.preventDefault();
        } else if (!link) {
          addToast("Coming soon!");
          e.preventDefault();
        }
      }}
      target="_blank"
      rel="noopener noreferrer"
      className={cx("SidebarLink flex items-center px-8 my-1", {
        "theme-text-on-primary rounded theme-bg-primary": active,
        "theme-text-heading-2 hover:theme-bg-default": !active,
      })}>
      {label}
      <PremiumChip isAvailable={isPremiumAvailable} className="ml-auto" />
    </a>
  );
}

export default withToast(
  connect((s) => ({
    communityPac: s.communityPac,
  }))(CommunitySettingSidebarComponent)
);
